export function formatDate (date: Date): string {
  return date.toLocaleDateString('en-US')
}

const longDateFormatter = new Intl.DateTimeFormat('en-US')
const shortDateFormatter = new Intl.DateTimeFormat('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
const shortTimeFormatter = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: 'numeric' })
export const dateTimeFormatters = {
  toShortDate: (date:Date): string => {
    return shortDateFormatter.format(date)
  },
  toDateTime: (date:Date): string => {
    return longDateFormatter.format(date) + ' ' + shortTimeFormatter.format(date)
  }
}
